import { colors } from '@cerifi/theme/colors'

import { darkenColor } from '../../utils/color-helpers'
import { BackgroundShape, ShapeType } from './image-shape-svg'

export interface BackgroundShapeType {
  shapeName: ShapeType
  align: 'center' | 'left' | 'right'
}

function getShapeColor(color: string) {
  if (!color) return null

  switch (color.toUpperCase()) {
    case colors.tan[100]:
      return colors.tan[300]
    case colors.lightBlue[50]:
      return colors.lightBlue[100]
    case colors.navy.DEFAULT:
      return colors.navy[800]
    default:
      return darkenColor(color, 5)
  }
}

export const CmsBackgroundShape = (props: {
  content: BackgroundShapeType
  color: string
  style?: any
}) => {
  return (
    <BackgroundShape
      style={{
        color: getShapeColor(props.color),
        ...props.style,
      }}
      name={props.content.shapeName}
      align={props.content.align}
    />
  )
}
